import { ActorType } from '@/types/enum/ActorType';
import { Actor, Address, Project, ProjectActorModel } from '@/types';

const DELIMITER = ' - ';

/**
 * Formatter pour différentes données d'un acteur.
 */
const ActorFormatter = {

	/**
	 * Formatte l'affichage du nom d'acteur en fonction de son type.
	 */
	formatActorLabel(actor: Actor): string {
		let actorLabel = '';

		if (ActorType.HEALTH_PROFESSIONAL === actor.actorType) {
			actorLabel = `${actor.firstName} ${actor.lastName}`;
		}

		if (ActorType.HEALTH_INSTITUTION === actor.actorType) {
			actorLabel = actor.name;
		}

		return actorLabel;
	},

	/**
	 * Formatte l'affichage de l'identifiant d'un acteur en fonction de son type.
	 */
	formatActorIdentifier(actor: Actor): string {
		let actorIdentifier = '';

		if (ActorType.HEALTH_PROFESSIONAL === actor.actorType) {
			actorIdentifier = actor.am;
		}

		if (ActorType.HEALTH_INSTITUTION === actor.actorType) {
			actorIdentifier = (actor.amNumber) ? actor.amNumber : actor.finessGeographical;
		}

		return actorIdentifier;
	},

	formatActorLabelFromDisplayLabel(reference: string): string {
		return (reference.includes(DELIMITER)) ? reference.split(DELIMITER)[1] : reference;
	},

	formatActorIdentifierFromDisplayLabel(reference: string): string {
		return (reference.includes(DELIMITER)) ? reference.split(DELIMITER)[0] : reference;
	},

	/**
	 * Formatte l'affichage du nom ou prénom d'acteur en fonction de son type.
	 */
	formatActorInfoByType(actor: Actor, info: string): string {
		let actorInfo = '';

		if (ActorType.HEALTH_PROFESSIONAL === actor.actorType) {
			switch (info.toLowerCase()) {
				case 'firstname':
					actorInfo = `${actor.firstName}`;
					break;

				case 'lastname':
				default:
					actorInfo = `${actor.lastName}`;
			}
		}

		if (ActorType.HEALTH_INSTITUTION === actor.actorType) {
			actorInfo = actor.name;
		}

		return actorInfo;
	},

	/**
	 * Formatte l'affichage de l'adresse complete d'un acteur
	 */
	formatFullAddress(address: Address|null): string {
		if (address?.streetName) {
			return [
				address.streetNumber.trim(),
				address.streetType.trim(),
				address.streetName.trim()
			].filter(Boolean).join(' ');
		}

		return '';

	},

	formatResidentialAddress(actor: any, project: Project): string {
		const projectActor = actor?.projectActors?.find((obj: ProjectActorModel) => obj.project?.name === project.name);
		const address = projectActor?.residentialAddress;

		if (!address) {
			return '';
		}

		const city = [address.zipcode, address.city]
			.filter(Boolean)
			.join(' ');

		return [address.streetAddress, city]
			.filter(Boolean)
			.join(', ');
	}

};

export default ActorFormatter;
